<template>
  <div class="section fondu" :class="{'fonduenter': fields.length != 0}">

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>

    <div class="card">
      <div class="card-header">
        <p class="card-header-title">Gérer les contenus</p>
        <span class="icon has-text-info help-btn">
          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Contenus" target="_blank"><i class="fa fa-question-circle"></i></a>
        </span>
      </div>
      <div class="card-content principal">
        <div class="content">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">Créer un type de contenu</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Créer%20un%20type%20de%20contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="columns">
                    <div class="column">
                      <div class="field">
                        <label class="label">Nom type de contenu</label>
                        <div class="control">
                          <input v-if="!selectedContent" class="input" type="text" placeholder="e.g. Films" v-model="name">
                          <input v-else class="input" type="text" placeholder="e.g. Movies" v-model="selectedContent.name">
                        </div>
                      </div><br><br>
                      <div class="field">
                        <span class="icon has-text-info help-btn">
                          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Type%20de%20contenu%20multiple" target="_blank"><i class="fa fa-question-circle"></i></a>
                        </span>
                        <label class="label">Format de contenu</label>
                        <div class="control">
                          <checkbox v-if="!selectedContent" label="Contenu unique" v-model="single"/>
                          <checkbox v-else label="Contenu unique" v-model="selectedContent.single"/>
                        </div>
                      </div><br><br>
                      <!-- Custom Fields -->
                      <span class="icon has-text-info help-btn">
                        <a href="https://theadmin.thecompagnie.eu/doc?bloc=Créer%20un%20type%20de%20contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
                      </span>
                      <label class="label">Champs</label>
                      <div class="field is-grouped is-grouped-multiline">
                        <ul class="nav-preview">
                          <li v-for="(field, fieldKey) in checkedFields" :key="fieldKey" v-if="field.checked">
                            {{ field.name }}
                            <span class="link-actions">
                              <span v-if="fieldKey !== 0" class="has-text-success fa fa-arrow-up" @click="moveFieldUp(field, checkedFields[fieldKey - 1])"></span>
                              <span v-if="fieldKey !== checkedFields.length - 1" class="fa fa-arrow-down" @click="moveFieldDown(field, checkedFields[fieldKey + 1])"></span>
                              <span><checkbox v-if="field.type === 'textbox'" v-model="field.sortable" /> </span>
                            </span>
                          </li>
                        </ul>
                      </div>
                      <br />
                      <span class="is-size-7">Cochez en face du champ à afficher dans le tableau</span>
                    </div>
                    <div class="column">
                        <span class="icon has-text-info help-btn">
                          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Créer%20un%20type%20de%20contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
                        </span>
                        <label class="label">Champs disponibles</label>
                        <p class="is-size-7" v-if="fields.length" >Sélectionnez les champs à inclure dans le type de contenu</p>
                        <div class="field is-grouped is-grouped-multiline">
                          <ul class="nav-preview">
                          <li class="control"  v-for="(field, fieldKey) in fields" :key="fieldKey">
                            <span class="field">
                              <checkbox :label="field.name" v-model="field.checked"/>
                              <span class="link-actions">
                                <span class="has-text-danger fa fa-trash" @click="removeField(field)"></span>
                                <router-link :to="'/admin/content/fieldEdit/' + field['.key']"><span class="has-text-info fa fa-edit"></span></router-link>
                              </span>
                            </span>
                          </li>
                          </ul>
                        </div><br>
                        <router-link to="/admin/content/fieldNew" class="button is-info is-small">Ajouter un nouveau champ</router-link>
                      </div>
                    </div><br><br>
                  <div class="buttons">
                  <button v-if="selectedContent" type="submit" class="button is-success" :disabled="!selectedContent.name || !checkedFields.length" @click="createMenuItem(true)">Actualiser</button>
                  <button v-else type="submit" class="button is-success" :disabled="!name || !checkedFields.length" @click="createMenuItem(false)">Créer un nouveau</button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <router-view :edit-field="editField" :add-field="addField"></router-view>
          <br />
          <div class="card" v-if="contentsLoaded">
            <div class="card-header">
              <p class="card-header-title">Éditer un type de contenu</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Editer%20un%20type%20de%20contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="dropdown" :class="{'is-active': dropdownActive}" @click="toggleDropdown">
                  <div class="dropdown-trigger">
                    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" style="min-width: 200px !important;">
                      <span>{{selectedContentType.label}}</span>
                      <span class="icon is-small">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                      <a class="dropdown-item" v-if="option" v-for="(option, optionKey) in createdContentTypes" :key="optionKey" @click="selectContentType(option)">
                        {{option.label ? option.label : null }}
                      </a>
                    </div>
                  </div>
                </div>
                <button v-if="selectedContent" type="submit" class="button is-danger" @click="deleteMenuItem()">Supprimer</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkbox from '@/admin/components/shared/Checkbox'
import dropdown from '@/admin/components/shared/Dropdown'
import { contentsRef, fieldsRef } from '@/admin/firebase_config'
import notifier from '@/admin/mixins/notifier'
export default {
  name: 'content-type',
  mixins: [notifier],
  firebase: {
    contents: contentsRef,
    fields: fieldsRef
  },
  data () {
    return {
      name: '',
      single: false,
      selectedContentType: {
        id: '',
        label: 'Sélectionnez un type de contenu'
      },
      dropdownActive: false,
      selectedContent: null,
      contentsLoaded: false,
      selectedContntFields: null
    }
  },
  created () {
    this.clearChecked()
    this.loadContentTypes()
  },
  computed: {
    checkedFields () {
      return this.fields.filter(field => {
        return field.checked
      })
    },
    createdContentTypes () {
      const createdcontereturn = this.contents.map(content => {
        return {
          id: content['.key'],
          label: content.name
        }
      })
      createdcontereturn.push({id: '', label: 'Sélectionnez un type de contenu'})
      return createdcontereturn
    }
  },
  methods: {
    loadContentTypes () {
      this.contentsLoaded = false
      this.selectedContentType = {
        id: '',
        label: 'Sélectionnez un type de contenu'
      }
      this.contentsLoaded = true
    },
    createMenuItem (edit) {
      let path
      if (edit) {
        path = this.selectedContent.name.toLowerCase()
      } else {
        path = this.name.toLowerCase()
      }
      path = path.replace(/^[, ]+|[, ]+$|[, ]+/g, '').trim()

      let selectedFields = this.checkedFields.map(field => {
        if (!field.sortable) {
          field.sortable = false
        }
        return {
          name: field.name,
          type: field.type,
          sortable: field.sortable,
          multiValue: field.multiValue
        }
      })

      let item = {
        name: this.name,
        single: this.single,
        path: `/admin/content/${path}`,
        icon: 'fa-file-text',
        fields: selectedFields
      }
      if (edit) {
        this.selectedContent.path = `/admin/content/${path}`
        this.selectedContent.fields = selectedFields
        let item = {...this.selectedContent}
        delete item['.key']
        this.$firebaseRefs.contents.child(this.selectedContent['.key']).update(item).then(() => {
          this.resetForm()
          this.loadContentTypes()
          this.showNotification('success', 'Contenu édité avec succès')
        })
      } else {
        this.$firebaseRefs.contents.push(item).then(() => {
          this.loadContentTypes()
          this.showNotification('success', 'Contenu ajouté avec succès')
          this.resetForm()
        })
      }
    },
    deleteMenuItem () {
      this.$firebaseRefs.contents.child(this.selectedContent['.key']).remove()
        .then(() => {
          this.loadContentTypes()
          this.showNotification('success', 'Contenu supprimé avec succès')
        })
    },
    resetForm () {
      this.name = ''
      this.single = false
      this.selectedContent = null
      for (var fieldKey in this.fields) {
        this.fields[fieldKey].checked = false
      }
      for (var key in this.supports) {
        this.supports[key] = false
      }
    },
    addField (field) {
      this.$firebaseRefs.fields.push(field).then(() => {
        this.showNotification('success', 'Champ ajouté avec succès')
      })
    },
    editField (field, f) {
      this.$firebaseRefs.fields.child(field['.key']).set(f).then(() => {
        this.showNotification('success', 'Champ édité avec succès')
      })
    },
    removeField (field) {
      this.$firebaseRefs.fields.child(field['.key']).remove()
        .then(() => {
          this.showNotification('success', 'Champ supprimé avec succès')
        })
    },
    moveFieldUp (field, previousField) {
      let itemCopy = Object.assign({}, field)
      let previousItemCopy = Object.assign({}, previousField)

      delete itemCopy['.key']
      delete previousItemCopy['.key']

      this.$firebaseRefs.fields.child(field['.key']).set(previousItemCopy)
      this.$firebaseRefs.fields.child(previousField['.key']).set(itemCopy)
    },
    moveFieldDown (field, nextField) {
      let itemCopy = Object.assign({}, field)
      let nextItemCopy = Object.assign({}, nextField)

      delete itemCopy['.key']
      delete nextItemCopy['.key']

      this.$firebaseRefs.fields.child(field['.key']).set(nextItemCopy)
      this.$firebaseRefs.fields.child(nextField['.key']).set(itemCopy)
    },
    clearChecked () {
      for (var key in this.fields) {
        delete this.fields[key]['checked']
      }
    },
    selectContentType (option) {
      this.selectedContentType = option
      this.selectedContent = this.contents.filter(content => {
        if (content.name === option.label) {
          return content
        }
      })[0]
      this.clearChecked()
      if (option.id) {
        this.mapFields()
      }
    },
    toggleDropdown () {
      this.dropdownActive = !this.dropdownActive
    },
    mapFields () {
      for (var j = 0; j < this.fields.length; j++) {
        for (var i = 0; i < this.selectedContent.fields.length; i++) {
          if (this.selectedContent.fields[i].name === this.fields[j].name) {
            this.selectedContent.fields[i].checked = true
            this.$set(this.fields[j], 'checked', true)
          }
        }
      }
    }
  },
  components: {
    checkbox,
    dropdown
  }
}

</script>

<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/content/content-type/ContentType.vue